import { render, staticRenderFns } from "./SleepAlarm.vue?vue&type=template&id=2e18d7e6&scoped=true&"
import script from "./SleepAlarm.vue?vue&type=script&lang=js&"
export * from "./SleepAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18d7e6",
  null
  
)

export default component.exports